import { render, staticRenderFns } from "./LocalAgentBadge.vue?vue&type=template&id=4e7b7af9&scoped=true"
import script from "./LocalAgentBadge.vue?vue&type=script&lang=js"
export * from "./LocalAgentBadge.vue?vue&type=script&lang=js"
import style0 from "./LocalAgentBadge.vue?vue&type=style&index=0&id=4e7b7af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b7af9",
  null
  
)

export default component.exports